import { MouseParallaxContainer, MouseParallaxChild } from "react-parallax-mouse";
import { Outlet } from "react-router-dom";
import Footer from "./footer";
import TopNav from "./topnav";
import I1 from "../assets/1.png";
import I2 from "../assets/2.png";
import I3 from "../assets/asnaut.png";
import I4 from "../assets/bg_new.jpg";

import { useState, useEffect } from "react";

function HomeLayout() {
  return (
    <div className="relative w-screen h-screen">
      <div className="absolute top-0 left-0  w-full h-full">
        <BG />
      </div>
      <div className="absolute top-0 left-0  w-full h-full">
        <div className="w-full h-screen  overflow-y-auto style-scroll min-h-screen flex flex-col z-50 pt-16">
          <TopNav />
          <div className="flex-grow">
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default HomeLayout;

function BG() {
  const [m, setGlobalMousePos] = useState({ x: 0, y: 0, w: 0, h: 0 });

  useEffect(() => {
    const handleMouseMove = (event: any) => {
      setGlobalMousePos({
        x: (event.clientX / event.view.innerWidth) * 10,
        y: (event.clientY / event.view.innerHeight) * 10,
        w: event.view.innerWidth,
        h: event.view.innerHeight,
      });
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  return (
    <div className="relative h-screen overflow-hidden -mx-8" style={{ width: "105vw" }}>
      <img
        src={I4}
        alt=""
        className={`w-full h-full object-cover absolute`}
        style={{
          top: m.x,
          left: m.y,
        }}
      />
      <img
        src={I2}
        alt=""
        className={`w-[80%] h-[80%] object-contain absolute opacity-80 animate-pulse`}
        style={{
          top: m.h / 2.5 + m.x * -5,
          left: m.w / 4 + m.y * -5,
        }}
      />
      <img
        src={I3}
        alt=""
        className={`w-[60%] h-[60%] object-contain absolute`}
        style={{
          top: -20 + m.x * 4,
          left: m.w / 3 + m.y * 4,
        }}
      />
      <img
        src={I1}
        alt=""
        className={`w-[80%] h-[80%] object-contain absolute opacity-40 animate-spin`}
        style={{
          top: m.h / 20 + m.x * 10,
          left: m.w / 8 + m.y * 10,
        }}
      />
    </div>
  );
}
